<template>
  <v-layout column>
    <v-layout :column="$vuetify.breakpoint.xs">
      <v-flex v-if="attendeeFields[0].component === 'avatar-field'" shrink class="mr-16">
        <v-flex v-for="field in firstField" :key="field.key">
          <component
            :is="field.component"
            v-model="form[field.key]"
            :validator="vs && vs.form[field.key]"
            v-bind="field"
          />
        </v-flex>
      </v-flex>
      <v-flex>
        <v-layout column>
          <v-flex v-for="field in firstThreeFields" :key="field.key" class="pb-16">
            <v-combobox
              v-if="event.extraModules.expoMobileApp && field.key === 'Naziv tvrtke / Company name'"
              ref="companyComboboxField"
              v-model="form[field.key]"
              v-bind="field"
              :error-messages="getErrors(vs.form[field.key])"
              :items="suggestedCompanies"
              :search-input.sync="form[field.key]"
              item-text="name"
              item-value="name"
              box
              append-icon=""
              hide-no-data
              :loading="suggestionsLoading"
              @change="populateSuggested"
              @blur="onCompanySelectBlur"
              @input="onCompanyInputChange"
            />
            <component
              :is="field.component"
              v-else
              v-model="form[field.key]"
              :validator="vs && vs.form[field.key]"
              v-bind="field"
              :error-messages="{
                ...field.errorMessages,
                required: [2444, 4531].includes(Number(event.id))
                  ? 'Ovo polje je obavezno'
                  : 'This field is required',
              }"
              @input="
                ;[2444, 4531].includes(Number(event.id)) &&
                  ['First name', 'Last name'].includes(field.key) &&
                  uppercase(field.key)
              "
            />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout column>
      <v-flex v-if="!category && event.extraModules.categoriesAndZones" class="pb-16">
        <select-field
          :value="form.category"
          :items="event.categories"
          :validator="vs.form.category"
          :label="styles.category || 'Category'"
          item-render="name"
          item-select="id"
          @change="onCategoryChange"
        />
      </v-flex>
      <v-flex
        v-if="event.extraModules.categoriesAndZones && event.numberOfZones > 0"
        v-show="form.category"
        class="pb-16"
      >
        <zone-picker-field
          v-model="form.zones"
          :number-of-zones="event.numberOfZones"
          :validator="vs.form.zones"
          :label="styles.zones || 'Zones'"
        />
      </v-flex>
      <v-flex v-for="field in otherFields" :key="field.key" class="pb-16">
        <div v-if="['Images', 'Files'].includes(field.key)">
          <div v-if="form[field.key] && form[field.key].length > 0">
            <label class="v-label theme--light">{{ field.label }}</label>
            <div v-for="(url, index) in form[field.key]" :key="index" class="mt-2">
              Download:
              <a :href="url" target="_blank" download>
                {{ (url || '').split('/').pop() }}
              </a>
            </div>
          </div>
        </div>
        <component
          :is="field.component"
          v-else
          v-model="form[field.key]"
          :validator="vs && vs.form[field.key]"
          v-bind="field"
          :error-messages="{
            ...field.errorMessages,
            email: [2444, 4531].includes(Number(event.id))
              ? 'Molimo obavezno navedite email'
              : 'This field must be an email',
            required: [2444, 4531].includes(Number(event.id))
              ? 'Ovo polje je obavezno'
              : 'This field is required',
            maxLength:
              [2444, 4531].includes(Number(event.id)) && field.key == 'Tvrtka/ustanova'
                ? 'Molimo skratite naziv na 32 znakova (npr. Ministarstvo regionalnog razvoja i fondova Europske unije upisati kao MRRFEU).'
                : 'This field should contain less values',
          }"
          @input="
            ;[2444, 4531].includes(Number(event.id)) &&
              field.key == 'Tvrtka/ustanova' &&
              uppercase(field.key)
          "
        />
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
import { SEARCH_EXPO_COMPANIES } from '@/graphql/expoCompany.graphql'
import { defaultMessages, getValidationErrors } from '@/utils'

export default {
  name: 'accreditation-form',
  props: {
    event: {
      type: Object,
      default: null,
    },
    category: {
      type: Object,
      default: () => {},
    },
    initialValues: {
      type: Object,
      default: () => {},
    },
    vs: {
      type: Object,
      default: () => {},
    },
    styles: {
      type: Object,
      default: () => ({}),
    },
    publicForm: {
      type: Boolean,
      default: true,
    },
    fields: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      form: {},
      attendeeFields: this.fieldOrder(),
      suggestedCompanies: [],
      requestInProgress: undefined,
      suggestionsLoading: false,
    }
  },
  computed: {
    firstField() {
      return this.attendeeFields.slice(0, 1)
    },
    firstThreeFields() {
      if (this.attendeeFields[0].component === 'avatar-field') {
        return this.attendeeFields.slice(1, 4)
      } else {
        return this.attendeeFields.slice(0, 4)
      }
    },
    otherFields() {
      return this.attendeeFields.slice(4)
    },
  },
  watch: {
    form: {
      handler(val) {
        this.$emit('values', val)
      },
      deep: true,
    },
    '$i18next.resolvedLanguage': function () {
      this.attendeeFields.forEach(val => {
        val.label = this.$t(val.key)
      })
    },
  },

  mounted() {
    const initial = { zones: [], ...this.initialValues }
    this.form = Object.entries(this.$route.query).reduce((acc, [key, value]) => {
      const replaced = key.split('_').join(' ')
      if (!value || !this.fields.find(f => f.key === replaced)) return acc
      acc[replaced] = value

      return acc
    }, initial)
  },
  methods: {
    fieldOrder() {
      let attendeefields = [...this.fields]
      const eventId = this.event.id
      console.log(attendeefields)
      attendeefields.forEach(
        function (item, i) {
          if (item.isPrivate) {
            attendeefields.splice(i, 1)
          }
          if (item.component === 'avatar-field') {
            attendeefields.splice(i, 1)
            attendeefields.unshift(item)
          }
          if (item.key === 'First name' && [2444, 4531].includes(Number(eventId)))
            item.label = 'Ime'
          if (item.key === 'Last name' && [2444, 4531].includes(Number(eventId)))
            item.label = 'Prezime'
        }.bind(this),
      )
      attendeefields = attendeefields
        .filter(
          f => !(f.label === 'Datum rodenja' && [952, 2444, 4531].includes(parseInt(eventId))),
        )
        .filter(f => !(f.label === 'OIB' && [2444, 4531].includes(Number(eventId))))
        .filter(f => f.label !== 'entryTo' && f.label !== 'entryFrom')

      return attendeefields
    },

    async onCategoryChange(categoryId) {
      if (this.form.category === categoryId) return
      const category = this.event.categories.find(({ id }) => id === categoryId)
      if (category) this.form = { ...this.form, zones: category.zones, category: category.id }
    },

    uppercase(field) {
      this.form[field] = this.form[field].toUpperCase()
    },

    getErrors: function (field) {
      return getValidationErrors({
        ...defaultMessages,
        ...this.errorMessages,
      })(field)
    },

    async populateSuggested(input) {
      if (!(typeof input === 'string') || !input || !input.trim()) return

      if (this.requestInProgress) clearTimeout(this.requestInProgress)
      this.suggestionsLoading = true
      this.requestInProgress = setTimeout(async () => {
        const {
          data: { searchExpoCompanies },
          errors,
        } = await this.$apollo.query({
          query: SEARCH_EXPO_COMPANIES,
          variables: {
            eventId: this.event.id,
            searchTerm: input,
          },
        })

        if (!errors) {
          this.suggestedCompanies = searchExpoCompanies
        }
        this.suggestionsLoading = false
      }, 500)
    },
    onCompanySelectBlur() {
      if (this.vs.form['Naziv tvrtke / Company name']) {
        this.vs.form['Naziv tvrtke / Company name'].$touch()
      }
      if (this.$refs.companyComboboxField && this.$refs.companyComboboxField.length) {
        this.$refs.companyComboboxField[0].$data.isMenuActive = false
        this.$refs.companyComboboxField[0].$data.isFocused = false
      }
    },
    onCompanyInputChange(value) {
      this.form['OIB / Company VAT number'] = value.OIB
    },
  },
}
</script>

<style scoped></style>
